import { isCurrentView } from "../../../shared/utils/view-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.product_selection")) {
    return;
  }

  const recommendedBtn = document.getElementById("recommended_btn");
  const allSolutionsBtn = document.getElementById("all_solutions_btn");
  const submitButton = document.getElementById("submit-button");

  const hasOnline = document.getElementById(
    "omj_shopify_order_form_online",
  ).value;
  const hasRemote = document.getElementById(
    "omj_shopify_order_form_remote",
  ).value;
  const hasInPerson = document.getElementById(
    "omj_shopify_order_form_in_person",
  ).value;

  const onlineOption = document.getElementById("online_option");
  const remoteOption = document.getElementById("remote_option");
  const cardOption = document.getElementById("card_option");
  const qrOption = document.getElementById("qr_option");
  const posOption = document.getElementById("pos_option");

  const learnMoreQr = document.getElementById("learn_more_qr");
  const qrContainer = document.getElementById("qr_container");
  const paymentLinkCheckbox = document.getElementById(
    "omj_shopify_order_form_payment_link",
  );
  const learnMorePaymentLink = document.getElementById(
    "learn_more_payment_link",
  );
  const paymentLinkContainer = document.getElementById(
    "payment_link_container",
  );
  const eComCheckbox = document.getElementById(
    "omj_shopify_order_form_e_commerce",
  );
  const learnMoreEcommerce = document.getElementById("learn_more_e_commerce");
  const eCommerceContainer = document.getElementById("e_commerce_container");
  const posCheckbox = document.getElementById(
    "omj_shopify_order_form_pos_integration",
  );
  const learnMorePOS = document.getElementById("learn_more_pos_integration");
  const posContainer = document.getElementById("pos_integration_container");
  const qrCheckbox = document.getElementById("omj_shopify_order_form_qr");
  const perspexBlockContainer = document.getElementById("perspex_container");
  const perspexSnapcodeRadioFalse = document.getElementById(
    "omj_shopify_order_form_perspex_snapcode_false",
  );

  const inPersonProducts = [qrCheckbox.checked, posCheckbox.checked];
  const onlineProducts = { name: "e_com", checked: eComCheckbox.checked };
  const remoteProducts = {
    name: "payment_link",
    checked: paymentLinkCheckbox.checked,
  };

  addCheckboxEventListeners();

  if (qrCheckbox) {
    if (qrCheckbox.checked) {
      toggleDisplay(perspexBlockContainer);
    }
    qrCheckbox.addEventListener("click", function () {
      toggleDisplay(perspexBlockContainer);
      if (!qrCheckbox.checked) {
        perspexSnapcodeRadioFalse.checked = true;
      }
    });
  }

  if (recommendedBtn) {
    recommendedBtn.addEventListener("click", function () {
      allSolutionsBtn.classList.remove("tab-active");
      recommendedBtn.classList.add("tab-active");
      recommendedDefaults();
    });
  }

  if (allSolutionsBtn) {
    allSolutionsBtn.addEventListener("click", function () {
      showAllSolutions();
    });
  }

  initializePaymentOptions();
  initializeActiveTab();

  if (learnMoreQr) {
    learnMoreQr.addEventListener("click", function () {
      showMore(qrContainer, learnMoreQr);
    });
  }
  if (learnMorePaymentLink) {
    learnMorePaymentLink.addEventListener("click", function () {
      showMore(paymentLinkContainer, learnMorePaymentLink);
    });
  }
  if (learnMoreEcommerce) {
    learnMoreEcommerce.addEventListener("click", function () {
      showMore(eCommerceContainer, learnMoreEcommerce);
    });
  }
  if (learnMorePOS) {
    learnMorePOS.addEventListener("click", function () {
      showMore(posContainer, learnMorePOS);
    });
  }

  function showMore(container, learnMore) {
    container.classList.toggle("animate-learn-more");
    learnMore.textContent = container.classList.contains("animate-learn-more")
      ? "Show less"
      : "Learn more";
  }

  function toggleDisplay(container) {
    if (!container) {
      return;
    }
    container.classList.toggle("animate");
  }
  function show(container) {
    if (!container) {
      return;
    }
    container.classList.remove("d-none");
    container.classList.add("d-flex");
  }
  function hide(container) {
    if (!container) {
      return;
    }
    container.classList.remove("d-flex");
    container.classList.add("d-none");
  }

  function initializePaymentOptions() {
    if (hasOnline === "true") {
      show(onlineOption);
    }
    if (hasRemote === "true") {
      show(remoteOption);
    }
    if (hasInPerson === "true") {
      show(cardOption);
      show(qrOption);
      show(posOption);
    }
  }

  function enableSubmit() {
    submitButton.disabled = !(
      qrCheckbox.checked ||
      posCheckbox.checked ||
      eComCheckbox.checked ||
      paymentLinkCheckbox.checked
    );
  }

  function addCheckboxEventListeners() {
    enableSubmit();
    qrCheckbox.addEventListener("change", enableSubmit);
    posCheckbox.addEventListener("change", enableSubmit);
    eComCheckbox.addEventListener("change", enableSubmit);
    paymentLinkCheckbox.addEventListener("change", enableSubmit);
  }

  function initializeActiveTab() {
    if (
      hasInPerson === "true" &&
      hasOnline === "true" &&
      hasRemote === "true"
    ) {
      return;
    }
    if (
      hasInPerson === "true" &&
      ((hasOnline === "false" && onlineProducts.checked) ||
        (hasRemote === "false" && remoteProducts.checked))
    ) {
      return showAllSolutions();
    }
    const inPersonProductSelected = inPersonProducts.includes(true);
    if (
      (hasOnline === "true" &&
        hasInPerson === "false" &&
        inPersonProductSelected) ||
      (hasRemote === "false" && remoteProducts.checked)
    ) {
      return showAllSolutions();
    }
    if (
      (hasRemote === "true" &&
        hasInPerson === "false" &&
        inPersonProductSelected) ||
      (hasOnline === "false" && onlineProducts.checked)
    ) {
      return showAllSolutions();
    }
    if (
      hasInPerson === "true" &&
      hasOnline === "true" &&
      remoteProducts.checked
    ) {
      return showAllSolutions();
    }
    if (
      hasInPerson === "true" &&
      hasRemote === "true" &&
      onlineProducts.checked
    ) {
      return showAllSolutions();
    }
    if (
      hasOnline === "true" &&
      hasRemote === "true" &&
      inPersonProductSelected
    ) {
      return showAllSolutions();
    }
  }

  function recommendedDefaults() {
    if (hasOnline === "false") {
      hide(onlineOption);
      defaultEcommerceState();
    }
    if (hasRemote === "false") {
      hide(remoteOption);
      defaultPaymentLinkState();
    }
    if (hasInPerson === "false") {
      hide(cardOption);
      hide(qrOption);
      hide(posOption);
      defaultPerspexSnapcodeState();
      defaultCardTerminalState();
      defaultPosState();
    }
  }

  function showAllSolutions() {
    recommendedBtn.classList.remove("tab-active");
    allSolutionsBtn.classList.add("tab-active");
    show(onlineOption);
    show(remoteOption);
    show(cardOption);
    show(qrOption);
    show(posOption);
  }

  function defaultPerspexSnapcodeState() {
    perspexBlockContainer.classList.remove("animate");
    qrContainer.classList.remove("animate-learn-more");
    qrCheckbox.checked = false;
    perspexSnapcodeRadioFalse.checked = true;
    learnMoreQr.textContent = "Learn more";
  }

  function defaultPosState() {
    posCheckbox.checked = false;
    posContainer.classList.remove("animate-learn-more");
    learnMorePOS.textContent = "Learn more";
  }

  function defaultPaymentLinkState() {
    paymentLinkCheckbox.checked = false;
    paymentLinkContainer.classList.remove("animate-learn-more");
    learnMorePaymentLink.textContent = "Learn more";
  }

  function defaultEcommerceState() {
    eComCheckbox.checked = false;
    eCommerceContainer.classList.remove("animate-learn-more");
    learnMoreEcommerce.textContent = "Learn more";
  }

  function defaultCardTerminalState() {
    // Placeholder for card terminal default state if needed
  }
});
